export const HOST = import.meta.env.VITE_API_URL

export const OPTIONS = {
	method: 'GET',
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json'
	}
}
